export function ReportsCtrl (
  $rootScope,
  $scope,
  $translate,
  $window,
  API,
  branchList,
  company,
  companyMessages,
  dateParsing,
  inheritorApi,
  internalOnlyTypes,
  limitTypes,
  locations,
  mechanicList,
  messages,
  orderColumns,
  orderStatusTypes,
  productTypes,
  searches,
  sessionObjAPI,
  transactionTypes,
  workshopAPI
) {

  $scope.branch_store_list                = branchList;
  $scope.company                          = company;
  $scope.companyMessages                  = companyMessages;
  $scope.customer_balances_order_list     = orderColumns.customer_balances;
  $scope.customer_listing_order_list      = orderColumns.customer_listing;
  $scope.internal_only_list               = internalOnlyTypes;
  $scope.item_purchases_order_list        = orderColumns.item_purchases;
  $scope.item_purchases_search_list       = searches.item_purchases;
  $scope.item_sales_order_list            = orderColumns.item_sales;
  $scope.item_sales_search_list           = searches.item_sales;
  $scope.limit_by_type_list               = limitTypes;
  $scope.loanCarHistoryOrderList          = orderColumns.loan_car_history;
  $scope.locations                        = locations;
  $scope.mechanicList                     = mechanicList;
  $scope.outstanding_balances_order_list  = orderColumns.outstanding_balances;
  $scope.purchases_report_order_list      = orderColumns.purchases_report;
  $scope.sales_report_search_list         = searches.sales_report;
  $scope.status_invoices_search_list      = orderColumns.status_invoices;
  $scope.stock_listing_order_list         = productTypes;
  $scope.stock_value_report_group_list    = orderColumns.stock_value_report;
  $scope.vehicle_acquisitions_order_list  = orderColumns.vehicle_acquisitions_report;
  $scope.vehicle_listing_order_list       = orderColumns.vehicle_listing;
  $scope.vehicle_sales_order_list         = orderColumns.vehicle_sales_report;
  $scope.vehicle_stock_listing_order_list = orderColumns.vehicle_stock_listing_report;
  $scope.vehicles_on_order_list           = orderColumns.vehicles_on_order_report;
  $scope.vendor_balances_order_list       = orderColumns.vendor_balances;
  $scope.vendor_listing_order_list        = orderColumns.vendor_listing;

  $scope.stock_listing_order_list.push({ code: '*', description: $translate.instant('GENERAL_SPACE.BUTTON.ALL') });

  inheritorApi.inheritCtrl('ReportsLiteCtrl', $scope);

  $scope.customer_biller_balances = {
    begin_date: '*',
    end_date  : '*',
    pdf       () {
      $window.open(`${API.url}/reports/customer_biller_balances/pdf/${$scope.customer_biller_balances.begin_date}/${$scope.customer_biller_balances.end_date}.pdf`);
    },
    csv       () {
      $window.open(`${API.url}/reports/customer_biller_balances/csv/${$scope.customer_biller_balances.begin_date}/${$scope.customer_biller_balances.end_date}`);
    }
  };

  $scope.customer_bulk_statements = {
    body   : $scope.companyMessages.statement_email_message,
    subject: $translate.instant('REPORT_SPACE.STATEMENT_SUBJECT', { name: $scope.company.company_name })
  };

  $scope.customer_listing = {
    order_by: '*',
    pdf () {
      $window.open(`${ API.url }/reports/customer_listing/pdf/${ workshopAPI.encode($scope.customer_listing.order_by) }.pdf`);
    },
    csv () {
      $window.open(`${ API.url }/reports/customer_listing/csv/${ workshopAPI.encode($scope.customer_listing.order_by) }`);
    }
  };

  $scope.customer_sales = {
    begin_date: '*',
    end_date  : '*',
    order_by  : '*',
    pdf () {
      $window.open(`${API.url}/reports/customer_sales_report/pdf/${this.begin_date}/${this.end_date}/${this.order_by}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/customer_sales_report/csv/${this.begin_date}/${this.end_date}/${this.order_by}`);
    },
    orderList: {
      customer: $translate.instant('JS_SPACE.COLUMNS.CUSTOMER_NAME'),
      rego    : $scope.labels.rego,
      date    : $translate.instant('GENERAL_SPACE.FIELD.DATE'),
      type    : $translate.instant('GENERAL_SPACE.FIELD.TYPE')
    }
  };

  $scope.customer_sources = {
    begin_date: '*',
    end_date  : '*',
    pdf () {
      $window.open(`${API.url}/reports/jasper_customer_sources/pdf/${$scope.customer_sources.begin_date}/${$scope.customer_sources.end_date}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/jasper_customer_sources/csv/${$scope.customer_sources.begin_date}/${$scope.customer_sources.end_date}`);
    }
  };

  $scope.customer_statements = {
    begin_date  : '*',
    end_date    : '*',
    include_paid: true,
    as_at       : '*',
    statement   : false,
    pdf () {
      $window.open(`${API.url}/reports/jasper_statements/*/${this.begin_date}/${this.end_date}/${this.include_paid}.pdf`);
    },
    pdf_306090 () {
      $window.open(`${API.url}/reports/jasper_statements_306090/*/${this.as_at}.pdf`);
    }
  };

  $scope.email_report = {
    begin_date: '*',
    end_date  : '*',
    pdf () {
      $window.open(`${API.url}/reports/email_report/pdf/${this.begin_date}/${this.end_date}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/email_report/csv/${this.begin_date}/${this.end_date}`);
    }
  };

  $scope.event_report = {
    begin_date: dateParsing.thisMonthStart(),
    end_date  : dateParsing.today(),
    pdf () {
      this.begin_date    = ( !this.begin_date || this.begin_date === '*' ) ? dateParsing.thisMonthStart() : this.begin_date;
      this.end_date      = ( !this.end_date   || this.end_date === '*' )   ? dateParsing.today() : this.end_date;

      $window.open(`${API.url}/reports/jasper_event_logs/pdf/${$scope.event_report.begin_date}/${$scope.event_report.end_date}.pdf`);
    },
    csv () {
      this.begin_date    = ( !this.begin_date || this.begin_date === '*' ) ? dateParsing.thisMonthStart() : this.begin_date;
      this.end_date      = ( !this.end_date   || this.end_date === '*' )   ? dateParsing.today() : this.end_date;

      $window.open(`${API.url}/reports/jasper_event_logs/csv/${$scope.event_report.begin_date}/${$scope.event_report.end_date}`);
    }
  };

  $scope.item_purchases = {
    begin_date: '*',
    end_date  : '*',
    pdf () {
      $scope.end_range   = this.end_range || 'zzzz';
      $scope.start_range = this.start_range || '0';

      $window.open(`${API.url}/reports/jasper_item_purchases_report/pdf/${this.begin_date}/${this.end_date}/${this.order_by}/${$scope.start_range}/${$scope.end_range}/${this.sort_range}/${this.summary}.pdf`);
    },
    csv () {
      $scope.end_range   = this.end_range || 'zzzz';
      $scope.start_range = this.start_range || '0';

      $window.open(`${API.url}/reports/jasper_item_purchases_report/csv/${this.begin_date}/${this.end_date}/${this.order_by}/${$scope.start_range}/${$scope.end_range}/${this.sort_range}/${this.summary}`);
    },
    start_range: '',
    end_range  : '',
    sort_range : '*',
    order_by   : '*',
    summary    : false
  };

  $scope.item_sales = {
    begin_date   : dateParsing.thisMonthStart(),
    end_date     : dateParsing.today(),
    internal_only: '*',
    branch       : sessionObjAPI.company().id,
    pdf () {
      this.begin_date  = ( !this.begin_date || this.begin_date === '*' ) ? dateParsing.thisMonthStart() : this.begin_date;
      this.end_date    = ( !this.end_date   || this.end_date === '*' )   ? dateParsing.today()          : this.end_date;
      this.end_range   = this.end_range     || 'zzzz';
      this.start_range = this.start_range   || '0';

      $window.open(`${API.url}/reports/jasper_item_sales_report/pdf/${this.begin_date}/${this.end_date}/${this.order_by}/${this.start_range}/${this.end_range}/${this.sort_range}/${this.summary}/${this.internal_only}/${this.branch}.pdf`);
    },
    csv () {
      this.begin_date  = ( !this.begin_date || this.begin_date === '*' ) ? dateParsing.thisMonthStart() : this.begin_date;
      this.end_date    = ( !this.end_date   || this.end_date === '*' )   ? dateParsing.today()          : this.end_date;
      this.end_range   = this.end_range     || 'zzzz';
      this.start_range = this.start_range   || '0';

      $window.open(`${API.url}/reports/jasper_item_sales_report/csv/${this.begin_date}/${this.end_date}/${this.order_by}/${this.start_range}/${this.end_range}/${this.sort_range}/${this.summary}/${this.internal_only}/${this.branch}`);
    },
    start_range: '',
    end_range  : '',
    sort_range : '*',
    order_by   : '*',
    summary    : false
  };

  $scope.loanCarHistory = {
    beginDate: '*',
    endDate  : '*',
    orderBy  : 'date',
    pdf () {
      $window.open(`${ API.url }/reports/jasper_loan_car_history/pdf/${ $scope.loanCarHistory.beginDate }/${ $scope.loanCarHistory.endDate }/${ $scope.loanCarHistory.orderBy }.pdf`);
    },
    csv () {
      $window.open(`${ API.url }/reports/jasper_loan_car_history/csv/${ $scope.loanCarHistory.beginDate }/${ $scope.loanCarHistory.endDate }/${ $scope.loanCarHistory.orderBy }`);
    }
  };

  $scope.mechanic_barcode_list = {
    print () {
      $window.open(`${API.url}/reports/jasper_mechanic_barcode_list.pdf`);
    }
  };

  $scope.mechanic_time_sheet = {
    mechanic_id: 0,
    pdf () {
      $window.open(`${API.url}/reports/mechanic_time_card/pdf/${$scope.mechanic_time_sheet.mechanic_id}/${$scope.mechanic_time_sheet.begin_date}/${$scope.mechanic_time_sheet.end_date}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/mechanic_time_card/csv/${$scope.mechanic_time_sheet.mechanic_id}/${$scope.mechanic_time_sheet.begin_date}/${$scope.mechanic_time_sheet.end_date}`);
    }
  };

  $scope.mechanicFlatRateReport = {
    begin_date : '*',
    end_date   : '*',
    mechanic_id: 0,
    summary    : false,
    pdf () {
      $window.open(`${API.url}/reports/mechanic_flat_rate/pdf/${ $scope.mechanicFlatRateReport.mechanic_id }/${ $scope.mechanicFlatRateReport.begin_date }/${ $scope.mechanicFlatRateReport.end_date }/${this.summary}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/mechanic_flat_rate/csv/${ $scope.mechanicFlatRateReport.mechanic_id }/${ $scope.mechanicFlatRateReport.begin_date }/${ $scope.mechanicFlatRateReport.end_date }/${this.summary}`);
    }
  };

  $scope.mechanics_clocked_on = {
    pdf () {
      $window.open(`${API.url}/reports/jasper_mechanic_clocked_on_report/pdf.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/jasper_mechanic_clocked_on_report/csv`);
    }
  };

  $scope.no_labor_times = {
    begin_date: '*',
    end_date  : '*',
    summary   : false,
    show_open : true,
    pdf () {
      $window.open(`${API.url}/reports/jasper_no_labor_times/pdf/${$scope.no_labor_times.begin_date}/${$scope.no_labor_times.end_date}/${$scope.no_labor_times.summary}/${$scope.no_labor_times.show_open}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/jasper_no_labor_times/csv/${$scope.no_labor_times.begin_date}/${$scope.no_labor_times.end_date}/${$scope.no_labor_times.summary}/${$scope.no_labor_times.show_open}`);
    }
  };

  $scope.open_deposits = {
    pdf () {
      $window.open(`${API.url}/reports/jasper_open_deposits/pdf.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/jasper_open_deposits/csv`);
    }
  };

  $scope.purchases_report = {
    begin_date: '*',
    end_date  : '*',
    sort_by   : 'S',
    pdf () {
      $window.open(`${API.url}/reports/purchases_report/pdf/${$scope.purchases_report.begin_date}/${$scope.purchases_report.end_date}/${$scope.purchases_report.sort_by}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/purchases_report/csv/${$scope.purchases_report.begin_date}/${$scope.purchases_report.end_date}/${$scope.purchases_report.sort_by}`);
    }
  };

  $scope.quote_report = {
    begin_date: '*',
    end_date  : '*',
    pdf () {
      $window.open(`${API.url}/reports/quote_report/pdf/${$scope.quote_report.begin_date}/${$scope.quote_report.end_date}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/quote_report/csv/${$scope.quote_report.begin_date}/${$scope.quote_report.end_date}`);
    }
  };

  $scope.sales_by_payment_method = {
    begin_date: '*',
    end_date  : '*',
    pdf () {
      $window.open(`${API.url}/reports/sales_by_payment_method/pdf/${$scope.sales_by_payment_method.begin_date}/${$scope.sales_by_payment_method.end_date}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/sales_by_payment_method/csv/${$scope.sales_by_payment_method.begin_date}/${$scope.sales_by_payment_method.end_date}`);
    }
  };

  $scope.sms_report = {
    beginDate: '*',
    endDate  : '*',
    pdf () {
      $window.open(`${API.url}/reports/sms_log/pdf/${ $scope.sms_report.beginDate }/${ $scope.sms_report.endDate }.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/sms_log/csv/${ $scope.sms_report.beginDate }/${ $scope.sms_report.endDate }`);
    }
  };

  $scope.status_invoices = {
    invoice_number: '',
    search_by     : 'customer_invoice',
    csv           : () => $window.open(`${ API.url }/reports/status_invoices/csv/${ $scope.status_invoices.invoice_number }/${ $scope.status_invoices.search_by }`),
    pdf           : () => $window.open(`${ API.url }/reports/status_invoices/pdf/${ $scope.status_invoices.invoice_number }/${ $scope.status_invoices.search_by }.pdf`)
  };

  $scope.stock_listing = {
    location   : '*',
    order_by   : '*',
    offset     : 0,
    print_zeros: true,
    pdf () {
      $window.open(`${API.url}/reports/stock_listing/pdf/${this.order_by}/${this.offset}/${this.print_zeros}/${ this.location }.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/stock_listing/csv/${this.order_by}/${this.offset}/${this.print_zeros}/${ this.location }`);
    }
  };

  $scope.stock_order = {
    begin_date : '*',
    end_date   : '*',
    outstanding: false,
    pdf () {
      $window.open(`${API.url}/reports/stock_order/pdf/${$scope.stock_order.begin_date}/${$scope.stock_order.end_date}/${$scope.stock_order.outstanding}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/stock_order/csv/${$scope.stock_order.begin_date}/${$scope.stock_order.end_date}/${$scope.stock_order.outstanding}`);
    }
  };

  $scope.stock_value = {
    print_zeros: true,
    group_by   : '*',
    location   : '*',
    pdf () {
      $window.open(`${API.url}/reports/stock_value/pdf/${this.print_zeros}/${ this.location }/${this.group_by}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/stock_value/csv/${this.print_zeros}/${ this.location }/${this.group_by}`);
    }
  };

  $scope.stockStatusReport = {
    begin_date: '*',
    branch    : $rootScope.Company.getId(),
    end_date  : '*',
    status    : '*',
    statuses  : orderStatusTypes,
    pdf () {
      $window.open(`${API.url}/reports/jasper_purchase_order_item_due_date/pdf/${$scope.stockStatusReport.begin_date}/${$scope.stockStatusReport.end_date}/${$scope.stockStatusReport.status}/${$scope.stockStatusReport.branch}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/jasper_purchase_order_item_due_date/csv/${$scope.stockStatusReport.begin_date}/${$scope.stockStatusReport.end_date}/${$scope.stockStatusReport.status}/${$scope.stockStatusReport.branch}`);
    }
  };

  $scope.stocktake_variance = {
    begin_date: '*',
    end_date  : '*',
    location  : '*',
    pdf () {
      $window.open(`${API.url}/reports/jasper_stocktake_variance/pdf/${$scope.stocktake_variance.begin_date}/${$scope.stocktake_variance.end_date}/${$scope.stocktake_variance.location}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/jasper_stocktake_variance/csv/${$scope.stocktake_variance.begin_date}/${$scope.stocktake_variance.end_date}/${$scope.stocktake_variance.location}`);
    }
  };

  $scope.tax_report = {
    begin_date: '*',
    end_date  : '*',
    summary   : false,
    pdf () {
      $window.open(`${API.url}/reports/jasper_tax_report/pdf/${$scope.tax_report.begin_date}/${$scope.tax_report.end_date}/${$scope.tax_report.summary}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/jasper_tax_report/csv/${$scope.tax_report.begin_date}/${$scope.tax_report.end_date}/${$scope.tax_report.summary}`);
    }
  };

  $scope.transaction_log = {
    begin_date: '*',
    end_date  : '*',
    trans_type: 'I',
    types     : transactionTypes,
    pdf () {
      $window.open(`${API.url}/reports/jasper_transaction_log/pdf/${this.begin_date}/${this.end_date}/${this.trans_type}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/jasper_transaction_log/csv/${this.begin_date}/${this.end_date}/${this.trans_type}`);
    }
  };

  $scope.vehicle_listing = {
    order_by: '*',
    pdf () {
      $window.open(`${ API.url }/reports/vehicle_listing/pdf/${ workshopAPI.encode($scope.vehicle_listing.order_by) }.pdf`);
    },
    csv () {
      $window.open(`${ API.url }/reports/vehicle_listing/csv/${ workshopAPI.encode($scope.vehicle_listing.order_by) }`);
    }
  };

  $scope.vehicleRegistrationLookups = {
    beginDate: '*',
    endDate  : '*',
    print    ( type = 'pdf' ) {
      $window.open(`${ API.url }/reports/jasper_purchased_request_log/${ type }/${this.beginDate}/${this.endDate}`);
    }
  };

  $scope.vendor_biller_balances = {
    begin_date: '*',
    end_date  : '*',
    pdf () {
      $window.open(`${API.url}/reports/vendor_biller_balances/pdf/${$scope.vendor_biller_balances.begin_date}/${$scope.vendor_biller_balances.end_date}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/vendor_biller_balances/csv/${$scope.vendor_biller_balances.begin_date}/${$scope.vendor_biller_balances.end_date}`);
    }
  };

  $scope.vendor_listing = {
    order_by: '*',
    pdf () {
      $window.open(`${ API.url }/reports/vendor_listing/pdf/${ workshopAPI.encode($scope.vendor_listing.order_by) }.pdf`);
    },
    csv () {
      $window.open(`${ API.url }/reports/vendor_listing/csv/${ workshopAPI.encode($scope.vendor_listing.order_by) }`);
    }
  };

  $scope.voided_report = {
    begin_date: '*',
    end_date  : '*',
    pdf () {
      $window.open(`${API.url}/reports/voided_report/pdf/${this.begin_date}/${this.end_date}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/voided_report/csv/${this.begin_date}/${this.end_date}`);
    }
  };

  $scope.work_in_progress = {
    begin_date: '*',
    end_date  : '*',
    summary   : false,
    pdf () {
      $window.open(`${API.url}/reports/jasper_work_in_progress/pdf/${$scope.work_in_progress.begin_date}/${$scope.work_in_progress.end_date}/${$scope.work_in_progress.summary}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/jasper_work_in_progress/csv/${$scope.work_in_progress.begin_date}/${$scope.work_in_progress.end_date}/${$scope.work_in_progress.summary}`);
    }
  };

  //DEALERSHIP REPORTS

  $scope.vehicle_acquisitions = {
    begin_date: '*',
    end_date  : '*',
    order_by  : 'S',
    pdf () {
      $window.open(`${API.url}/reports/jasper_vehicle_acquisitions/pdf/${$scope.vehicle_acquisitions.begin_date}/${$scope.vehicle_acquisitions.end_date}/${$scope.vehicle_acquisitions.order_by}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/jasper_vehicle_acquisitions/csv/${$scope.vehicle_acquisitions.begin_date}/${$scope.vehicle_acquisitions.end_date}/${$scope.vehicle_acquisitions.order_by}`);
    }
  };

  $scope.vehicles_on_order = {
    as_at_date: '*',
    order_by  : 'S',
    pdf () {
      $window.open(`${API.url}/reports/jasper_vehicles_on_order/pdf/${$scope.vehicles_on_order.as_at_date}/${$scope.vehicles_on_order.order_by}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/jasper_vehicles_on_order/csv/${$scope.vehicles_on_order.as_at_date}/${$scope.vehicles_on_order.order_by}`);
    }
  };

  $scope.vehicle_stock_listing = {
    order_by: 'S',
    pdf () {
      $window.open(`${API.url}/reports/jasper_vehicle_stock_listing/pdf/${$scope.vehicle_stock_listing.order_by}.pdf`);
    },
    csv () {
      $window.open(`${API.url}/reports/jasper_vehicle_stock_listing/csv/${$scope.vehicle_stock_listing.order_by}`);
    }
  };

  $scope.statement_send = function () {
    workshopAPI.post('/reports/jasper_statements_bulk', {
      email   : $scope.customer_bulk_statements,
      settings: $scope.customer_statements
    })
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.STATEMENTS_SENT_OVERNIGHT'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };
}